import "./SpecializedAreas.module.css";
import Header from "@/reusable_sections/Header";
import TailoredShineSolutions from "./sections/TailoredShineSolutions";
import BringTraditionToYourTable from "./sections/BringTraditionToYourTable";
import Footer from "@/reusable_sections/Footer";
export default function SpecializedAreasPage() {
  return <div>
      <Header />
      <TailoredShineSolutions />
      <BringTraditionToYourTable />
      <Footer />
    </div>;
}